module.exports = __webpack_public_path__ + "img/dp-banner.2cbeb254.png";